import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalOverlay,
} from '@chakra-ui/react';

interface ITwoButtonModal {
  isOpen: boolean;
  textLeft: string;
  textRight: string;
  onClose: () => void;
  onClickLeftButton: () => void;
  onClickRightButton: () => void;
  children: React.ReactNode;
}

function TwoButtonModal(props: ITwoButtonModal) {
  const onLeftButton = () => {
    props.onClickLeftButton();
    props.onClose();
  };
  const onRightButton = () => {
    props.onClickRightButton();
    props.onClose();
  };
  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} isCentered>
      <ModalOverlay />
      <ModalContent mx={'35px'}>
        <ModalBody px={'0px'}>{props.children}</ModalBody>
        <ModalFooter justifyContent={'center'} gap="10px" px={'0px'}>
          <Button
            colorScheme={'black_button'}
            w={'132px'}
            h="46px"
            fontSize={'14px'}
            fontWeight="semibold"
            onClick={onLeftButton}>
            {props.textLeft}
          </Button>
          <Button
            colorScheme={'mint'}
            w={'132px'}
            h="46px"
            fontSize={'14px'}
            fontWeight="semibold"
            onClick={onRightButton}>
            {props.textRight}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
export default TwoButtonModal;
